import { actions, paths } from 'src/constants';
import { MAX_PAGE_SIZE } from 'src/constants/common';

export default {
  getGroups: () => ({
    [actions.API_CALL]: {
      types: [
        actions.PAINTING_GROUPS_GET_REQUEST,
        actions.PAINTING_GROUPS_GET_SUCCESS,
        actions.PAINTING_GROUPS_GET_FAILURE,
      ],
      promise: (client) => client.get(paths.api.PAINTING_GROUPS),
    },
  }),
  getCollectionsByGroupId: (groupId, page, pageSize = MAX_PAGE_SIZE) => ({
    [actions.API_CALL]: {
      types: [
        actions.PAINTING_COLLECTIONS_GET_REQUEST,
        actions.PAINTING_COLLECTIONS_GET_SUCCESS,
        actions.PAINTING_COLLECTIONS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.build(paths.api.PAINTING_ID_COLLECTIONS, groupId), {
          params: {
            page,
            pageSize,
          },
        }),
    },
  }),
  getLevelsByCollectionId: (collectionId) => ({
    [actions.API_CALL]: {
      types: [
        actions.PAINTING_LEVELS_GET_REQUEST,
        actions.PAINTING_LEVELS_GET_SUCCESS,
        actions.PAINTING_LEVELS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(
          paths.build(paths.api.PAINTING_COLLECTIONS_ID_LEVELS, collectionId)
        ),
    },
  }),
};
